const INDUSTRY_OPTIONS = [
  { value: 'advancedManufacturingRobotics', label: 'Advanced Manufacturing & Robotics' },
  { value: 'aerospaceDefense', label: 'Aerospace & Defense' },
  { value: 'agricultureFood', label: 'Agriculture & Food' },
  { value: 'aiMl', label: 'AI/ML' },
  { value: 'apparelFashion', label: 'Apparel & Fashion' },
  { value: 'autoMobility', label: 'Auto & Mobility' },
  { value: 'biotech', label: 'Biotech' },
  { value: 'cannabis', label: 'Cannabis' },
  { value: 'chemicalMaterials', label: 'Chemical & Materials' },
  { value: 'cleanEnergy', label: 'Clean Energy' },
  { value: 'climateSustainability', label: 'Climate & Sustainability' },
  { value: 'cloudInfrastructure', label: 'Cloud Infrastructure' },
  { value: 'construction', label: 'Construction' },
  { value: 'consumerDigital', label: 'Consumer Digital' },
  { value: 'CPG', label: 'CPG' },
  { value: 'cryptoWeb3', label: 'Crypto & Web3' },
  { value: 'cybersecurity', label: 'Cybersecurity' },
  { value: 'dataAnalytics', label: 'Data Analytics' },
  { value: 'devOpsDeveloperTools', label: 'DevOps & Developer Tools' },
  { value: 'digitalMedia', label: 'Digital Media' },
  { value: 'dtc', label: 'DTC' },
  { value: 'eCommerce', label: 'E-commerce' },
  { value: 'edTech', label: 'EdTech' },
  { value: 'educationAcademia', label: 'Education & Academia' },
  { value: 'enterpriseSaas', label: 'Enterprise SaaS' },
  { value: 'entertainment', label: 'Entertainment' },
  { value: 'financialServices', label: 'Financial Services' },
  { value: 'fintech', label: 'Fintech' },
  { value: 'gaming', label: 'Gaming' },
  { value: 'governmentPolicy', label: 'Government & Policy' },
  { value: 'hardware', label: 'Hardware' },
  { value: 'healthcare', label: 'Healthcare' },
  { value: 'healthcareIt', label: 'Healthcare IT' },
  { value: 'humanResources', label: 'Human Resources' },
  { value: 'industrial', label: 'Industrial' },
  { value: 'infrastructure', label: 'Infrastructure' },
  { value: 'insurance', label: 'Insurance' },
  { value: 'iot', label: 'IoT' },
  { value: 'legalCompliance', label: 'Legal & Compliance' },
  { value: 'lifeSciences', label: 'Life Sciences' },
  { value: 'logisticsSupplyChain', label: 'Logistics & Supply Chain' },
  { value: 'manufacturing', label: 'Manufacturing' },
  { value: 'marketing', label: 'Marketing' },
  { value: 'medicalDevices', label: 'Medical Devices' },
  { value: 'mentalHealth', label: 'Mental Health' },
  { value: 'pharmaceuticals', label: 'Pharmaceuticals' },
  { value: 'professionalServices', label: 'Professional Services' },
  { value: 'propTechRealEstate', label: 'PropTech & Real Estate' },
  { value: 'quantumComputing', label: 'Quantum Computing' },
  { value: 'retail', label: 'Retail' },
  { value: 'roboticsAutomation', label: 'Robotics & Automation' },
  { value: 'semiconductors', label: 'Semiconductors' },
  { value: 'space', label: 'Space' },
  { value: 'sports', label: 'Sports' },
  { value: 'supplyChain', label: 'Supply Chain' },
  { value: 'talentRecruiting', label: 'Talent & Recruiting' },
  { value: 'telecom', label: 'Telecom' },
  { value: 'travelHospitality', label: 'Travel & Hospitality' },
  { value: 'vcPe', label: 'VC/PE' },
  { value: 'advertising', label: 'Advertising' },
  { value: 'adTech', label: 'Ad Tech' },
].sort((a, b) => a.label.localeCompare(b.label));

export { INDUSTRY_OPTIONS };
